import React, { createContext, useContext, useState, useEffect } from 'react';
import {
  TOKEN_KEY,
  ROLES_KEY,
  leggiToken,
  leggiRuoli,
  salvaSessione,
  pulisciSessione,
} from './services/sessione';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  /* Si legge la sessione NELL'INIZIALIZZATORE, non in una useEffect.
   *
   * Con la useEffect il primo render avveniva con token vuoto, e PrivateRoute
   * rimandava al login prima ancora che il valore salvato venisse letto:
   * ricaricare una pagina protetta, o aprirne il link diretto, buttava fuori
   * un utente regolarmente autenticato. La barra di navigazione si
   * aggiornava subito dopo, mostrando le voci da admin sopra un form di
   * accesso. Leggendo qui, il primo render ha gia' il valore giusto. */
  const [jwtToken, setJwtToken] = useState(leggiToken);
  const [userRoles, setUserRoles] = useState(leggiRuoli);

  /* Le schede aperte devono restare d'accordo fra loro.
   *
   * L'evento `storage` arriva alle ALTRE schede della stessa origine, mai a
   * quella che ha scritto. Senza questo, uscendo da una scheda le altre
   * restavano a mostrare un'interfaccia da utente autenticato finche' non si
   * ricaricavano, e la prima chiamata rispondeva 401. */
  useEffect(() => {
    const allinea = (e) => {
      if (e.key !== null && e.key !== TOKEN_KEY && e.key !== ROLES_KEY) return;
      setJwtToken(leggiToken());
      setUserRoles(leggiRuoli());
    };
    window.addEventListener('storage', allinea);
    return () => window.removeEventListener('storage', allinea);
  }, []);

  const login = (token, roles) => {
    const safeRoles = roles || [];
    setJwtToken(token);
    setUserRoles(safeRoles);
    salvaSessione(token, safeRoles);
  };

  const logout = () => {
    setJwtToken('');
    setUserRoles([]);
    pulisciSessione();
  };

  return (
    <AuthContext.Provider value={{ jwtToken, userRoles, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth deve essere utilizzato all'interno di un AuthProvider");
  }
  return context;
};
